import { startCase } from 'lodash';

export const interpolate = ['support', 'security', 'verification', 'wecare'].map((type) => ({
  getEmail: (domain: string, starsDomain: string) =>
    `${type}@${!domain || domain === 'starsdomain' ? starsDomain : domain}`,
  type,
  resolve: `contactUsMail${startCase(type)}Starsdomain`
}));
